import { render } from "./TableReprovado.vue?vue&type=template&id=b718b52c&scoped=true"
import script from "./TableReprovado.vue?vue&type=script&lang=js"
export * from "./TableReprovado.vue?vue&type=script&lang=js"

import "./TableReprovado.vue?vue&type=style&index=0&id=b718b52c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b718b52c"]])

export default __exports__